import { ChangeDetectorRef, Directive, effect, inject, input } from '@angular/core';
import { FilterBean, FilterRow } from '@type/filter.type';
import { FilterHelperService } from '../services/filter-helper/filter-helper.service';
import { FilterService } from '../services/filter/filter.service';

@Directive()
export abstract class BaseFilterItem<T extends FilterBean> {
  protected helper = inject(FilterHelperService);

  protected filterService = inject(FilterService);

  protected cdr = inject(ChangeDetectorRef);

  protected abstract getNecessaryProperties(filter: T): any;

  protected abstract convertFilterToChips(): string[];

  protected abstract resetFilterItem(item: BaseFilterItem<T>): void;

  protected abstract getDefaultFilter(): T;

  protected abstract processFilterForView(filter: unknown): void;

  protected abstract updateFilter(): void;

  public row = input.required<FilterRow>();

  public filter = this.getFilter();

  public get showCheckboxForEmptyValue() {
    return this.helper.options().showCheckboxForEmptyValue;
  }

  public get showCheckboxForFilledValue() {
    return this.helper.options().showCheckboxForFilledValueForFilters.includes(this.filter.type);
  }

  public get chips() {
    return this.convertFilterToChips();
  }

  constructor() {
    effect(() => this.patchFilter());
  }

  private patchFilter(): void {
    this.filter = this.getFilter(this.row().name);
    this.processFilterForView(this.filter);
  }

  reset(event: MouseEvent, item: BaseFilterItem<T>) {
    event.preventDefault();
    this.resetFilterItem(item);
    this.updateFilterChangeTime();
  }

  getFilter(key: string | null = null): T {
    if (key) {
      this.cdr.markForCheck();
      return this.filterService.getFilter(key) || this.getDefaultFilter();
    } else {
      return this.getDefaultFilter();
    }
  }

  updateFilterChangeTime() {
    this.updateFilter();
    this.applyFilter();
    this.filterService.tick();
  }

  private applyFilter() {
    this.filterService.setFilter(this.row().name, {
      ...this.getNecessaryProperties(this.filter),
      type: this.filter.type,
      name: this.filter.name,
    });
  }
}
